import React, { useState, useEffect } from "react";
import { getToken } from "../../utils/common";
import ReactTableComponent from "../Table/ReactTablecomponent";

function BookingTable(props) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);

  useEffect(() => {
    fetchBookingsData();
  }, []);

  const fetchBookingsData = () => {
    fetch(process.env.REACT_APP_API_ENDPOINT + "/group_portal/bookings", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw Error("Verification failed");
      })
      .then((response) => {
        setData(response);
      })
      .catch((err) => console.log(err));
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Number",
        accessor: "number",
        maxWidth: 150,
        Cell: (props) => {
          return <p style={{ width: "120px" }}>{props.value}</p>;
        },
      },
      {
        Header: "Guest Count",
        accessor: "total_guests",
      },
      {
        Header: "Status",
        accessor: "status",
        width: 60,
        Cell: (props) => {
          return (
            <>
              <div>{props.value}</div>
            </>
          );
        },
      },
      {
        Header: "Web Check In",
        accessor: "web_checkin_completed",
        width: 60,
        Cell: (props) => {
          return (
            <>
              {props.value ? (
                <div >Completed</div>
              ) : (
                <div>
                  <div>
                      <a href={`https://www.cordeliacruises.com/webCheckIn`} target="_blank" className="text-j-magenta underline pointer">Complete Web Check In</a>
                  </div>
                </div>
              )}
            </>
          );
        },
      },
    ],
    []
  );
  return (
    <div>
      <h1 className="text-xl font-bold p-4 text-j-magenta">Bookings</h1>
      <div className="ml-8 mr-8">
        <div className="overflow-x-auto">
          <div className="min-w-screen bg-gray-100 flex items-center justify-center bg-gray-100 font-sans overflow-hidden">
            <ReactTableComponent
              columns={columns}
              data={data}
              loading={loading}
              //   renderRowSubComponent={RenderRowSubComponent}
              count={totalPages}
              page={page}
              //   handlePageChange={handlePageChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default BookingTable;
